import { useLocation } from 'react-router-dom'

import { CreditPolicyForm } from '../forms'
import { PanelBox } from '../default'

/**
 * Displays the create credit policy panel.
 *
 * @author Maria Eduarda Franke, Isadora Botassari
 * @returns {React.Component} The rendered CreateCreditPolicyPanel component.
 */
const CreateCreditPolicyPanel = () => {

    const location = useLocation()

    const selectedCreditPolicy = location.state ? location.state.selectedCreditPolicy : null

    return (
        <PanelBox title={selectedCreditPolicy ? 'Editar Política de Crédito' : 'Criar Política de Crédito'}>
            <CreditPolicyForm selectedCreditPolicy={selectedCreditPolicy} />
        </PanelBox>
    )
}

export default CreateCreditPolicyPanel